<template>
  <div class="container">
    <el-row style="margin-bottom:20px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/director-audition-list' }">面试宝</el-breadcrumb-item>
        <el-breadcrumb-item>面试设置</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    <el-form ref="form" :model="form" label-width="120px">
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
      <el-tab-pane label="人员设置" name="first">
        <div>
            <el-form-item label="面试官">
              <el-select v-model="form.users" multiple placeholder="请选择">
                <el-option
                  v-for="item in userList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="面试邀约人">
              <el-select v-model="form.users" multiple placeholder="请选择">
                <el-option
                  v-for="item in userList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          
            
          </div>

      </el-tab-pane>

      <el-tab-pane label="考核项设置" name="second">
    
      <el-form-item
        v-for="(domain, index) in dynamicValidateForm.domains"
        :label="'考核项' + (index+1)"
        :key="domain.key"
        :prop="'domains.' + index + '.value'"
        :rules="{
          required: true, message: '考核项不能为空', trigger: 'blur'
        }"
      >
        <el-input v-model="domain.value"></el-input><el-button @click.prevent="removeDomain(domain)">删除</el-button>
    </el-form-item>
    <el-form-item>
      <el-button @click="addDomain">新增考核项</el-button>
    </el-form-item>
      

      </el-tab-pane>
      <el-tab-pane label="信息卡设置" name="third">

        <el-form-item label="姓名" prop="pass">
          <el-input  autocomplete="off"></el-input>
        </el-form-item>
     
        <el-form-item label="年龄" prop="age">
          <el-input ></el-input>
        </el-form-item>
     


      </el-tab-pane>
      <el-tab-pane label="其他设置" name="fourth">

          <el-form-item label="面试公告">
                <el-input type="textarea" v-model="form.desc"></el-input>
              </el-form-item>
      </el-tab-pane>
     
    </el-tabs>
  </el-form>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        activeName: 'first',
        userList:[],
        dynamicValidateForm: {
          domains: [{
            value: ''
          }],
          email: ''
        },
        form: {
          users:[],
          name: '',
          region: '',
          date1: '',
          date2: '',
          delivery: false,
          type: [],
          resource: '',
          desc: ''
        }
      };
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      },

      removeDomain(item) {
        var index = this.dynamicValidateForm.domains.indexOf(item)
        if (index !== -1) {
          this.dynamicValidateForm.domains.splice(index, 1)
        }
      },
      addDomain() {
        this.dynamicValidateForm.domains.push({
          value: '',
          key: Date.now()
        });
      }
    }
  };
</script>